
export type ModalConfig = { closeable?: boolean };

export const DEFAULT_MODAL_CONFIG: ModalConfig = {
    closeable: true
};

export type ModalState = 'open' | 'closed' | 'hidden';

export const MOBILE_DRAWER_RESOLUTION = 600;
